export default __webpack_public_path__ + "static/media/NVSP.61e36511.png";